"use strict";
/**
 * Podpowiedzi ostatnio używanych wartości, trzymane w przeglądarce na tym urządzeniu.
 *
 * Powód istnienia: wpisy powstają na telefonie, więc każde pole, którego nie trzeba
 * wystukać na ekranowej klawiaturze, jest realną oszczędnością. Kwoty przesyłek to
 * w praktyce dwie stawki, adresaci się powtarzają, a płacący i data prawie zawsze
 * są te same co przy poprzednim wpisie.
 *
 * Świadomie `localStorage`, nie backend: to wygoda jednej osoby na jednym telefonie,
 * a nie dane firmowe. Awaria pamięci przeglądarki nie może niczego zablokować, więc
 * każdy odczyt kończy się pustą listą zamiast wyjątkiem.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECENT_KEYS = void 0;
exports.remember = remember;
exports.recall = recall;
exports.lastUsed = lastUsed;
exports.forget = forget;
const PREFIX = "pettyCash.recent.";
const LIMIT = 6;
function read(key) {
    try {
        const raw = window.localStorage.getItem(PREFIX + key);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed.filter((v) => typeof v === "string") : [];
    }
    catch {
        return [];
    }
}
function write(key, values) {
    try {
        window.localStorage.setItem(PREFIX + key, JSON.stringify(values.slice(0, LIMIT)));
    }
    catch {
        // Pamięć pełna albo wyłączona — podpowiedzi są wygodą, nie warunkiem pracy.
    }
}
/** Najnowsze na początku, bez duplikatów, maksymalnie sześć. */
function remember(key, value) {
    const trimmed = value.trim();
    if (!trimmed)
        return read(key);
    const next = [trimmed, ...read(key).filter((v) => v !== trimmed)].slice(0, LIMIT);
    write(key, next);
    return next;
}
function recall(key) {
    return read(key);
}
/** Ostatnio użyta wartość — do podstawienia w nowym formularzu. */
function lastUsed(key) {
    return read(key)[0] ?? null;
}
function forget(key) {
    try {
        window.localStorage.removeItem(PREFIX + key);
    }
    catch {
        // jak wyżej
    }
}
exports.RECENT_KEYS = {
    payer: "payer",
    addressee: "addressee",
    itemAmount: "itemAmount",
};
